import {createElement, forwardRef} from 'react';
const SVGToComponent = forwardRef(
    (props, ref) => createElement(
        'svg',
        {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","dangerouslySetInnerHTML":{"__html":"<path d=\"M12.25 3.75L3.75 12.25\" stroke=\"#495366\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M3.75 3.75L12.25 12.25\" stroke=\"#495366\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"}, ...props, ref}
    )
);
SVGToComponent.displayName = "Close";
export default SVGToComponent;